module.exports = __webpack_public_path__ + "static/apple-icon-144x144-8afb8729ea8e8d95143ca0e4dc7fbdf3.png";